import { Component, Inject } from '@angular/core';
import { BessMetadata, ComponentLevelCount, StorageLevelV2, Topology } from '@twaice-fe/shared/models';
import { capitalizeFirstLetter } from '@twaice-fe/shared/utilities';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'twaice-fe-storage-metadata-dialog',
  templateUrl: 'storage-metadata-dialog.component.html',
  standalone: false,
})
export class StorageMetadataDialogComponent {
  readonly storageLevel = StorageLevelV2;
  protected readonly capitalizeFirstLetter = capitalizeFirstLetter;

  constructor(
    @Inject(NZ_MODAL_DATA)
    public data: { bessMetadata: BessMetadata | null; componentCountOnLevels: ComponentLevelCount[]; topology: Topology }
  ) {}

  get bessMetadata() {
    return this.data.bessMetadata;
  }

  get topology() {
    return this.data.topology;
  }

  get storageLocation() {
    if (!this.bessMetadata) return '';

    if (this.bessMetadata.locationCountry && this.bessMetadata.locationCity) {
      return `${this.bessMetadata.locationCountry}, ${this.bessMetadata.locationCity}`;
    } else {
      return this.bessMetadata.locationCountry || this.bessMetadata.locationCity || '';
    }
  }

  getComponentCountOnLevels({ type }: { type: 'electrical' | 'physical' }) {
    const sortOrder =
      type === 'electrical'
        ? [
            StorageLevelV2.Transformer,
            StorageLevelV2.ACCombiner,
            StorageLevelV2.PCS,
            StorageLevelV2.PCSModule,
            StorageLevelV2.DCCombiner,
            StorageLevelV2.StringGroup,
            StorageLevelV2.StringPCS,
            StorageLevelV2.String,
            StorageLevelV2.StringModulePCS,
            StorageLevelV2.StringModule,
            StorageLevelV2.Cell,
          ]
        : [StorageLevelV2.Enclosure];
    return (this.data.componentCountOnLevels ?? [])
      .filter((counts) => sortOrder.includes(counts.levelBk as StorageLevelV2))
      .sort((a, b) => sortOrder.indexOf(a.levelBk as StorageLevelV2) - sortOrder.indexOf(b.levelBk as StorageLevelV2));
  }

  keepOrder() {
    return 0;
  }
}
